import {PressureUnit} from '@/common/constants/units';

const roundDecimal = (val: number) => Math.round(val * 10) / 10;

export function pressureReduce(pascalValue: number, unit: PressureUnit) {
	switch (unit) {
		case PressureUnit.hPa:
			return Math.round(pascalValue / 100);

		case PressureUnit.mmHg:
			return Math.round(pascalValue * 7.50062 * Math.pow(10, -3));

		case PressureUnit.dmHg:
			return roundDecimal((pascalValue * 7.50062 * Math.pow(10, -3)) / 25.4);
	}
}
